import React from 'react';
import PropTypes from 'prop-types';
import translate from 'components/hoc/translate';
import styled from 'styled-components';

const StyledBox = styled.div`
    margin: 20px;
    padding: 20px;
    border: 2px solid RGBA(249, 168, 37, 1.00);
    background: RGBA(249, 168, 37, .2);
    font-size: 1rem;
    line-height: 1.6rem;
    text-align: center;
`;

const StyledTitle = styled.div`
    display: block;
    font-size: 1.4rem;
    margin-bottom: 10px;
    font-weight: 600;
`;

const CookiesDisabledLogin = (props) => {
    const {
        translate,
    } = props;

    return (
        <StyledBox>
            <StyledTitle>
                { translate('auth.login.noCookies.title') }
            </StyledTitle>

            { translate('auth.login.noCookies.description') }
        </StyledBox>
    );
};

CookiesDisabledLogin.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(CookiesDisabledLogin);



// WEBPACK FOOTER //
// ./src/pages/login/CookiesDisabledLogin.js